// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Pagination metadata returned in paginated list responses.
 */
export class PaginationMeta implements flatbuffers.IUnpackableObject<PaginationMetaT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): PaginationMeta {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsPaginationMeta(bb: flatbuffers.ByteBuffer, obj?: PaginationMeta): PaginationMeta {
    return (obj || new PaginationMeta()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsPaginationMeta(
    bb: flatbuffers.ByteBuffer,
    obj?: PaginationMeta,
  ): PaginationMeta {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new PaginationMeta()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  page(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  limit(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  total(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt64(this.bb_pos + offset) : 0n;
  }

  totalPages(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startPaginationMeta(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addPage(builder: flatbuffers.Builder, page: number) {
    builder.addFieldInt32(0, page, 0);
  }

  static addLimit(builder: flatbuffers.Builder, limit: number) {
    builder.addFieldInt32(1, limit, 0);
  }

  static addTotal(builder: flatbuffers.Builder, total: bigint) {
    builder.addFieldInt64(2, total, 0n);
  }

  static addTotalPages(builder: flatbuffers.Builder, totalPages: number) {
    builder.addFieldInt32(3, totalPages, 0);
  }

  static endPaginationMeta(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createPaginationMeta(
    builder: flatbuffers.Builder,
    page: number,
    limit: number,
    total: bigint,
    totalPages: number,
  ): flatbuffers.Offset {
    PaginationMeta.startPaginationMeta(builder);
    PaginationMeta.addPage(builder, page);
    PaginationMeta.addLimit(builder, limit);
    PaginationMeta.addTotal(builder, total);
    PaginationMeta.addTotalPages(builder, totalPages);
    return PaginationMeta.endPaginationMeta(builder);
  }

  unpack(): PaginationMetaT {
    return new PaginationMetaT(this.page(), this.limit(), this.total(), this.totalPages());
  }

  unpackTo(_o: PaginationMetaT): void {
    _o.page = this.page();
    _o.limit = this.limit();
    _o.total = this.total();
    _o.totalPages = this.totalPages();
  }

  unpackFields(...fields: string[]): PaginationMetaT {
    const t = new PaginationMetaT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("page")) {
      t.page = this.page();
    }
    if (fieldSet.has("limit")) {
      t.limit = this.limit();
    }
    if (fieldSet.has("total")) {
      t.total = this.total();
    }
    if (fieldSet.has("total_pages")) {
      t.totalPages = this.totalPages();
    }
    return t;
  }
}

export class PaginationMetaT implements flatbuffers.IGeneratedObject {
  constructor(
    public page: number = 0,
    public limit: number = 0,
    public total: bigint = 0n,
    public totalPages: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return PaginationMeta.createPaginationMeta(
      builder,
      this.page,
      this.limit,
      this.total,
      this.totalPages,
    );
  }

  clone(): PaginationMetaT {
    const obj = new PaginationMetaT();
    obj.page = this.page;
    obj.limit = this.limit;
    obj.total = this.total;
    obj.totalPages = this.totalPages;
    return obj;
  }

  equals(other: PaginationMetaT): boolean {
    if (this.page !== other.page) return false;
    if (this.limit !== other.limit) return false;
    if (this.total !== other.total) return false;
    if (this.totalPages !== other.totalPages) return false;
    return true;
  }
}

export function verifyPaginationMeta(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 8);
    verifier.checkScalarField(tablePos, 10, 4);
  } finally {
    verifier.popDepth();
  }
}
